
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/kognitiv",
      function () {
        return require("private-next-pages/destinations/kognitiv.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/kognitiv"])
      });
    }
  